import { Reveal } from "./Reveal";
import { XMatrix } from "./XMatrix";

const VECTORS = [
  { pair: ["Need", "Opportunity"], tag: "CAPITAL & SPACES" },
  { pair: ["Person", "Person"], tag: "NETWORK & TALENT" },
  { pair: ["Business", "Customer"], tag: "COMMERCE & GROWTH" },
  { pair: ["Problem", "Solution"], tag: "EXECUTION" },
  { pair: ["Idea", "Expertise"], tag: "INNOVATION" },
];

export const XSection = () => (
  <section id="the-x" data-testid="the-x-section" className="relative py-28 lg:py-40 overflow-hidden border-t border-white/5">
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(ellipse 50% 55% at 28% 50%, rgba(0,240,255,0.06), transparent 65%)" }}
    />
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-[1fr_1.2fr] gap-16 lg:gap-10 items-center">
      <Reveal className="relative max-w-md mx-auto lg:mx-0 w-full">
        <XMatrix animate={false} />
        <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 font-mono-accent text-[10px] tracking-[0.4em] text-slate-600 whitespace-nowrap">
          FIG. 01 — THE INTERSECTION
        </span>
      </Reveal>

      <div>
        <Reveal>
          <span className="font-mono-accent text-xs tracking-[0.3em] text-[#00F0FF]" data-testid="x-eyebrow">
            /// THE X
          </span>
          <h2 className="mt-6 font-display font-extrabold uppercase text-3xl sm:text-4xl lg:text-5xl leading-[1.02] text-slate-100" data-testid="x-title">
            Where both sides <span className="text-[#00F0FF]">meet</span>.
          </h2>
          <p className="mt-6 text-slate-400 text-base sm:text-lg leading-relaxed max-w-xl">
            The X is the point of intersection — where people, needs, opportunities and
            solutions cross. Every connection on FINDXCHANGE happens at the X.
          </p>
        </Reveal>

        <div className="mt-12 border-t border-white/10">
          {VECTORS.map((v, i) => (
            <Reveal key={v.tag} delay={i * 0.07}>
              <div
                className="group flex items-baseline justify-between gap-6 py-5 border-b border-white/10 transition-colors duration-300 hover:border-[#00F0FF]/40"
                data-testid={`x-vector-${i}`}
              >
                <span className="font-display font-bold uppercase text-xl sm:text-2xl lg:text-3xl text-slate-200 tracking-tight transition-transform duration-300 group-hover:translate-x-2">
                  {v.pair[0]} <span className="text-[#00F0FF]">×</span> {v.pair[1]}
                </span>
                <span className="font-mono-accent text-[10px] sm:text-xs tracking-[0.25em] text-slate-600 group-hover:text-slate-400 transition-colors whitespace-nowrap">
                  {v.tag}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
